<template>
    <x-page title="Edit Master Metric">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <metric-form id="metric-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="metric-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { getPreviousUrl, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import MetricForm from './MetricForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MetricForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/metrics/${this.$route.params.id}`, {
                params: {
                    load: 'category'
                }
            })
            .then(response => {
                this.resource = response.data.data
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/metrics/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.name} updated!`,
                    })
                    window.location = getPreviousUrl()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>